import React from 'react';

function Header(){
    return(
        <React.Fragment>
            <div className="heading">
                <h1>Top Web Series of All Time</h1>
            </div>
        </React.Fragment>
    );
}

export default Header;